import * as React from 'react';
import TranscriptionAllowanceForm from './TranscriptionAllowanceForm';
import LiveAllowanceForm from './LiveAllowanceForm';

interface Props {
  userId: string;
}

const AllowanceSection = (props: Props) => {
  return (
    <>
      <TranscriptionAllowanceForm {...props} />
      <LiveAllowanceForm {...props} />
    </>
  );
};

export default AllowanceSection;